import request from "@/config/utils/request";

// 编辑
export function postEditPcConcMat(data) {
  return request({
    url: "/apis/demo/pcconcmat/editPcConcMat",
    method: "POST",
    data
  });
}
// 添加
export function postAddPcConcMat(data) {
  return request({
    url: "/apis/demo/pcconcmat/savePcConcMat",
    method: "POST",
    data
  });
}
// 删除
export function postDeletePcConcMat(data) {
  return request({
    url: "/apis/demo/pcconcmat/removePcConcMat", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function postGetDetail(data) {
  return request({
    url: "/apis/demo/pcconcmat/getPcConcMatById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function postGetList(data) {
  return request({
    url: "/apis/demo/pcconcmat/listPcConcMatPage",
    method: "POST",
    data
  });
}
